import { z } from "zod";
import { COLORS } from "../../colors";
import { REGIONS } from "../../misc";
import { addressRequiredSchema } from "../address";
import { businessHoursSchema } from "./business-hours.schema";
import type { UploadResultsSchema } from "../files";
import { ZodIbanNullable } from "../zod-types/zod-iban-nullable";
import { ZodStringNullable } from "../zod-types/zod-string-nullable";

export const workspaceLegalSchema = z
	.object({
		blocks: z.array(z.array(z.string().min(1))).optional(),
	})
	.optional();

export const workspaceSchema = z
	.object({
		name: z.string().min(3).max(50),
		color: z.enum(COLORS),
		companyName: z.string().optional(),
		phone: ZodStringNullable,
		email: ZodStringNullable,
		web: ZodStringNullable,
		legal: workspaceLegalSchema,
		/** The account the workspace pays its suppliers from. */
		bankAccountHolder: ZodStringNullable,
		iban: ZodIbanNullable,
		bic: ZodStringNullable,
		/** The Bundesland whose holidays the workspace observes beside the nationwide ones. */
		region: z.enum(REGIONS).nullable(),
		/** When the workspace is open; null takes the organisation's hours. */
		businessHours: businessHoursSchema,
	})
	.and(addressRequiredSchema);

export type WorkspaceLegalSchema = z.infer<typeof workspaceLegalSchema>;

export type WorkspaceSchema = z.infer<typeof workspaceSchema>;

export type WorkspaceMediaSchema = {
	workspaceLetterpaper?: UploadResultsSchema;
	workspaceLogo?: UploadResultsSchema;
};
